export default __webpack_public_path__ + "static/Configurations 1 – 800x400-b60021f632c44aa1e07b90f63f2a18e2.png";